export default __webpack_public_path__ + "maps-examples-image-source-thumbnail-960-4f842fa138ae6d8ead6883c44e5080f1.png";